// SDK lexer token types — mirrors pkg/sdklex/types.go

export enum TokenType {
  SessionStart = 0,
  TextDelta = 1,
  TextDone = 2,
  ToolStart = 3,
  ToolInputDelta = 4,
  ToolDone = 5,
  TurnComplete = 6,
  Result = 7,
  Error = 8,
  ThinkingDelta = 9,
  ThinkingDone = 10,
}

export interface Token {
  type: TokenType;
  ts: number;
  data?: unknown;
}

export interface SessionStartData {
  session_id: string;
  model?: string;
}

export interface TextDeltaData {
  text: string;
}

export interface ToolStartData {
  tool_id: string;
  tool_name: string;
}

export interface ToolInputDeltaData {
  partial_json: string;
}

export interface ToolDoneData {
  tool_id: string;
  tool_name: string;
  full_input: string;
  parsed_input?: Record<string, unknown>;
}

export interface ResultData {
  session_id: string;
  cost_usd?: number;
  duration?: string;
  result?: string;
}

export interface ErrorData {
  raw: string;
  err: string;
}

export interface ThinkingDeltaData {
  text: string;
}

export interface ThinkingDoneData {
  thinking: string;
  signature?: string;
}

// Assembled blocks for rendering (accumulated from token stream)

export interface TextBlock {
  kind: 'text';
  content: string;
}

export interface ToolBlock {
  kind: 'tool';
  toolId: string;
  toolName: string;
  input: string;
  parsedInput?: Record<string, unknown>;
  done: boolean;
}

export interface ResultBlock {
  kind: 'result';
  sessionId: string;
  costUsd: number;
  duration: string;
}

export interface ThinkingBlock {
  kind: 'thinking';
  content: string;
  signature?: string;
  done: boolean;
}

export interface ErrorBlock {
  kind: 'error';
  message: string;
}

export type ContentBlock = TextBlock | ThinkingBlock | ToolBlock | ResultBlock | ErrorBlock;

export interface TurnMessage {
  id: number;
  role: 'user' | 'assistant';
  blocks: ContentBlock[];
}
